module.exports = "/assets/data/e6fb2b53ffa07152b473c635debb7f87-DA6.data.json";